import { throttle } from "../../lib";

export default class PinnedNavModule {
	constructor($root) {
		this.$root = $root;
		this.currentOffset = null;
		this.headerOffset = null;

		this.init();
	}

	init() {
		this.getOffset();
		this.toggle();
		this.addEventListeners();
	}

	addEventListeners() {
		window.addEventListener('scroll', throttle(() => {
			this.toggle();
		}, 20));
	}

	getOffset() {
		const mediaMatches = window.matchMedia('(min-width: 768px)').matches;
		const headerHeight = this.$root.offsetHeight;

		if (!mediaMatches) {
			this.headerOffset = headerHeight;

			if (document.body.classList.contains('-school') && document.body.classList.contains('-homepage')) {
				const $heroSectionLogo = document.querySelector('.section-content_logo');
				this.headerOffset = $heroSectionLogo.getBoundingClientRect().top + window.scrollY + $heroSectionLogo.scrollHeight;
			}

			return;
		}

		const siteNavHeight = this.$root.querySelector('.site-header-nav').offsetHeight;

		this.headerOffset = headerHeight + siteNavHeight;
	}

	toggle() {
		this.currentOffset = window.scrollY;

		if (this.currentOffset > this.headerOffset) {
			this.show();
		} else {
			this.hide();
		}
	}

	show() {
		this.$root.classList.add('-pinned');
	}

	hide() {
		this.$root.classList.remove('-pinned');
	}
}